import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.verticalMedium};
  padding: ${tokens.spacing.verticalSmall} 0;
`

export const Illustration = styled.img`
  width: 200px;
  height: auto;
  align-self: center;
`

export const Description = styled.p`
  font-size: ${tokens.fontSize.medium};
  color: ${tokens.colors.dark5};
  text-align: center;
  margin: 0;
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.verticalXsmall};
  margin-top: ${tokens.spacing.verticalSmall};
`
